import { render } from "./AddNewShield.vue?vue&type=template&id=296fb69c&lang=html"
import script from "./AddNewShield.vue?vue&type=script&lang=js"
export * from "./AddNewShield.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__